export default __webpack_public_path__ + "static/media/Up.f69b78ad.png";